/* eslint react-hooks/exhaustive-deps: 0 */

import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import helpers from 'utils/helpers';
import { Helmet } from 'react-helmet';
import { Row, Col } from 'antd';
import { toString, get, forEach, map, find, toLower } from 'lodash';
import validator from 'validator';

import { getCouponsRequest, addCouponRequest } from 'ducks/users';
import { StyledButton, StyledInput, StyledFormItem } from 'components/Styled';
import Coupon from './Coupon';

const PromoCode = props => {
  const state = {};
  const { t } = useTranslation();
  const prevProps = helpers.usePrevious(props) || {};

  helpers.setState(state, {
    uiLoaded: false,
    code: {
      value: '',
      status: '',
      help: ''
    }
  });

  const validations = {};

  const addRule = (prefix, label, type = 'required') => {
    validations[label] = {
      type,
      messages: {
        empty: t(`${prefix}.err_msg.${label}.empty`),
        format: t(`${prefix}.err_msg.${label}.format`)
      }
    };
  };

  const prefix = 'promo_codes';
  addRule(prefix, 'code', 'required');

  const authentication = () => {
    if (props.user) {
      props.getCouponsRequest({ user: props.user });
    } else if (props.user === false) {
      props.history.push('/login');
    }
  };

  useEffect(() => {
    if (!prevProps.addCouponSuccess && props.addCouponSuccess) {
      helpers.message.success(
        window.t('error_code.add-coupon-success'),
        'account'
      );
      props.getCouponsRequest({ user: props.user });
    }
  }, [props.addCouponSuccess]);

  useEffect(() => {
    if (!prevProps.user !== props.user) {
      authentication();
    }
  }, [props.user]);

  useEffect(() => {
    if (!prevProps.coupons && props.coupons) {
      helpers.setState(state, {
        uiLoaded: true
      });
    }

    if (props.coupons && state.code.value !== '') {
      const coupon = find(props.coupons, coupon => {
        return toLower(coupon.code) === toLower(state.code.value);
      });

      if (coupon) {
        window.dataLayer.push({
        event: 'Promo Code Success',
          promoData: {
            code: state.code.value,
            discountValue: coupon?.value
          }
        });
      }
    }
  }, [props.coupons]);

  useEffect(() => {
    authentication();
    window.dataLayer.push({
      event: 'Land Promo Page'
    });
  }, []);

  const handleTextInputChange = (value, label) => {
    helpers.setState(state, {
      [label]: {
        ...state[label],
        value
      }
    });
  };

  const handleTextInputBlur = label => {
    validate(label);
  };

  const validate = label => {
    const results = getErrorMessage(label);

    helpers.setState(state, {
      [label]: {
        ...state[label],
        status: results ? 'error' : '',
        help: results
      }
    });

    return !results;
  };

  const getErrorMessage = label => {
    let patterns;
    const value = toString(state[label].value);

    if (value.length > 35) {
      return t('common.err_msg.length');
    }

    switch (validations[label].type) {
      case 'required':
        patterns = /^[0-9A-Z\s\-_.,/'"():;$&@!?]+$/i;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return get(validations[label], 'messages.empty');
        }

        if (!patterns.test(value)) {
          return get(validations[label], 'messages.format');
        }

        return null;
      default:
        return null;
    }
  };

  const renderTextInput = label => {
    return (
      <StyledFormItem
        validateStatus={state[label].status}
        help={t(state[label].help)}>
        <StyledInput
          size="large"
          value={state[label].value}
          onChange={e => {
            handleTextInputChange(e.target.value, label);
          }}
          onBlur={e => {
            handleTextInputBlur(label);
          }}
        />
      </StyledFormItem>
    );
  };

  const handleSubmit = e => {
    e.preventDefault();
    handleClick();
  };

  const handleClick = () => {
    const fields = ['code'];
    let success = true;

    forEach(fields, label => {
      if (!validate(label)) {
        success = false;
      }
    });

    if (!success) {
      helpers.message.error(t('error_code.add-coupon-fail-empty'), 'account');
      return;
    }

    window.dataLayer.push({
      event: 'Submit Promo Code',
      promoData: {
        code: state.code.value
      }
    });

    props.addCouponRequest({ user: props.user, code: state.code.value });
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>{t('promo_codes.header.title')}</title>
      </Helmet>
      <div
        style={{
          backgroundColor: '#f5f5f5',
          margin: '0 auto',
          width: '100%',
          height: '100%',
          maxWidth: `${process.env.REACT_APP_MAX_WIDTH}px`,
          overflow: 'hidden'
        }}>
        <div
          style={{
            padding: '25px 15px 40px',
            backgroundColor: '#fff',
            boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.2)'
          }}>
          <div
            style={{
              fontSize: '20px',
              fontWeight: 700
            }}>
            {t('promo_codes.input_promo_code')}
          </div>
          <form onSubmit={handleSubmit}>
            <div style={{ padding: '20px 0' }}>{renderTextInput('code')}</div>
            <StyledButton
              type="primary"
              htmlType="submit"
              loading={props.loading}
              block
              shadow="true">
              {t('button.confirm')}
            </StyledButton>
          </form>
        </div>
        <div style={{ padding: '20px 15px 70px' }}>
          <Row type="flex" align="bottom">
            <Col>
              <span
                style={{
                  fontSize: '20px',
                  fontWeight: 700
                }}>
                {t('promo_codes.my_codes')}
              </span>
            </Col>
            <Col
              flex={1}
              style={{
                textAlign: 'right',
                fontSize: '12px'
              }}>
              {t('promo_codes.use_before_payment')}
              <br />
              <strong>
                ({t('promo_codes.no_speedpost')})
              </strong>
            </Col>
          </Row>
          <div
            style={{
              margin: '20px 0',
              borderTop: '1px solid #ccc'
            }}></div>
          {state.uiLoaded ? (
            <React.Fragment>
              {(() => {
                if (props.coupons.length) {
                  return map(props.coupons, coupon => {
                    return <Coupon key={coupon.code} coupon={coupon} />;
                  });
                }

                return (
                  <div style={{ color: '#2C2C2E', fontSize: '12px' }}>
                    {t('promo_codes.no_coupon')}
                  </div>
                );
              })()}
            </React.Fragment>
          ) : null}
        </div>
      </div>
    </React.Fragment>
  );
};

const mapDispatchToProps = {
  getCouponsRequest,
  addCouponRequest
};

const mapStateToProps = state => {
  return {
    user: state.auth.user,
    loading: !!(state.users.loading && state.users.coupons),
    coupons: state.users.coupons || false,
    addCouponSuccess: !!state.users.addCouponSuccess
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PromoCode));
